import { AppTester } from 'supporting';

/** Подписи свитчера */
export const getTeamEditLangSwitcherLabels = (): readonly ['ZH', 'EN'] | undefined =>
    AppTester.isNewDafesSegment() ? (['ZH', 'EN'] as const) : undefined;
import { AppTester } from 'supporting';

/** Подписи свитчера */
export const getTeamEditLangSwitcherLabels = (): readonly ['ZH', 'EN'] | undefined =>
    AppTester.isNewDafesSegment() ? (['ZH', 'EN'] as const) : undefined;
